import React from "react";
import { NavLink, Outlet, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, ClipboardList, Building2, CalendarClock, Factory, BarChart3, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/academies", label: "Academies", icon: Building2 },
  { to: "/admin/rounds", label: "Preorders", icon: CalendarClock },
  { to: "/admin/production", label: "Production", icon: Factory },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
];

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0A0A0C] flex flex-col lg:flex-row">
      <aside className="lg:w-60 lg:min-h-screen border-b lg:border-b-0 lg:border-r border-white/10 bg-black shrink-0">
        <Link to="/" className="flex items-center gap-2.5 p-5 border-b border-white/10">
          <img src="/paragon-logo.jpeg" alt="Paragon" className="h-10 w-10 rounded-full" />
          <div>
            <div className="font-heading font-black uppercase text-white leading-none">Paragon</div>
            <div className="font-mono text-[9px] tracking-widest text-yellow-400 uppercase">Admin OS</div>
          </div>
        </Link>
        <nav className="flex lg:flex-col p-3 gap-1 overflow-x-auto">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 rounded-md font-heading font-semibold uppercase text-sm tracking-wide whitespace-nowrap transition-colors ${
                  isActive ? "bg-yellow-400/15 text-yellow-400" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <l.icon className="h-4 w-4" /> {l.label}
            </NavLink>
          ))}
          <button
            data-testid="admin-logout"
            onClick={async () => { await logout(); navigate("/"); }}
            className="flex items-center gap-3 px-4 py-3 rounded-md font-heading font-semibold uppercase text-sm tracking-wide text-zinc-500 hover:text-red-400"
          >
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </nav>
      </aside>
      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}

export function downloadCsv(api, path, filename) {
  api.get(path, { responseType: "blob" }).then(({ data }) => {
    const url = URL.createObjectURL(data);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  });
}
